import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useReactToPrint } from "react-to-print";
import * as yup from "yup";

import Button from "components/Button";
import DatePicker from "components/DatePicker";
import Input from "components/Input";
import { usePatientQuote } from "providers/Quote/PatientQuote";
import { ReportSearchData } from "types/quotes";
import { defaultReportPeriod } from "utils/fetchConcludedQuotes";

import * as C from "./styles";

const PatientQuoteReportSearch = () => {
  const { reportSearchData, setReportSearchData, patientQuotesReportGlobalRef } =
    usePatientQuote();

  const [openDropdown, setOpenDropdown] = useState(false);

  const componentRef = useRef(patientQuotesReportGlobalRef?.current ?? null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Relatório dos Orçamentos Concluídos",
  });

  const handleTextInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    setValue("professionalName", inputValue);

    if (!inputValue) {
      setReportSearchData({
        ...reportSearchData,
        professionalName: "",
      });
    }
  };

  const handleIdQuoteInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;

    setValue("idQuote", inputValue);

    if (!inputValue) {
      setReportSearchData({
        ...reportSearchData,
        idQuote: null,
      });
    }
  };

  const clearFilters = () => {
    const period = defaultReportPeriod();
    reset({
      professionalName: "",
      idQuote: null,
      beginDate: period.beginDate.format("YYYY-MM-DD"),
      endDate: period.endDate.format("YYYY-MM-DD"),
    });
    setReportSearchData(period);
  };

  const schema = yup.object().shape({
    professionalName: yup.string(),
    idQuote: yup.string().nullable(),
    beginDate: yup.date().typeError("*Data inválida").nullable(),
    endDate: yup.date().typeError("*Data inválida").nullable(),
  });

  const { register, handleSubmit, control, setValue, reset } =
    useForm<ReportSearchData>({
      resolver: yupResolver(schema),
      defaultValues: {
        professionalName: reportSearchData.professionalName ?? "",
        idQuote: reportSearchData.idQuote ?? "",
        beginDate: reportSearchData.beginDate
          ? moment(reportSearchData.beginDate).format("YYYY-MM-DD")
          : null,
        endDate: reportSearchData.endDate
          ? moment(reportSearchData.endDate).format("YYYY-MM-DD")
          : null,
      },
    });

  const onSubmit = async (data: ReportSearchData) => {
    setReportSearchData(data);
    setOpenDropdown(false);
  };

  useEffect(() => {
    componentRef.current = patientQuotesReportGlobalRef;
  }, [patientQuotesReportGlobalRef]);

  return (
    <div className="row gx-2">
      <div className="col col-auto pb-2">
        <Button
          className="btn-sm btn-outline-primary"
          onClick={() => {
            componentRef.current = patientQuotesReportGlobalRef;
            handlePrint();
          }}
        >
          <i className="uil uil-print mr-2" />
          Imprimir Relatório
        </Button>
      </div>

      <form className="col col-auto pb-2" onSubmit={handleSubmit(onSubmit)}>
        <C.Container>
          <Dropdown autoClose={false} show={openDropdown}>
            <Dropdown.Toggle
              id="dropdown-basic"
              variant="dark"
              size="sm"
              onClick={() => setOpenDropdown(!openDropdown)}
            >
              FILTROS
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{
                width: "90vw",
                maxHeight: "29rem",
                maxWidth: "22rem",
                overflowY: "auto",
                zIndex: 3,
                paddingBottom: 0,
              }}
            >
              <Dropdown.Header className="lh-1">FILTROS</Dropdown.Header>

              <Dropdown.Divider />

              <Dropdown.ItemText>
                <div className="row">
                  <div className="form-group col-12 w-full">
                    <Input
                      label="Nome do Profissional"
                      labelClassName="small text-muted mb-0"
                      type="text"
                      placeholder="Nome do Médico"
                      register={register("professionalName")}
                      onChange={handleTextInput}
                      defaultValue={reportSearchData.professionalName}
                    />
                  </div>

                  <div className="form-group col-12 w-full">
                    <Input
                      label="Id do Orçamento"
                      labelClassName="small text-muted mb-0"
                      type="number"
                      placeholder="Id do Orçamento"
                      register={register("idQuote")}
                      onChange={handleIdQuoteInput}
                      defaultValue={reportSearchData.idQuote ?? ""}
                    />
                  </div>

                  <div className="form-group col-6 w-full">
                    <DatePicker
                      label="Período de"
                      labelClassName="small text-muted mb-0"
                      control={control}
                      name="beginDate"
                      defaultValue={null}
                    />
                  </div>

                  <div className="form-group col-6 w-full">
                    <DatePicker
                      label="Período até"
                      labelClassName="small text-muted mb-0"
                      control={control}
                      name="endDate"
                      defaultValue={null}
                    />
                  </div>
                </div>
              </Dropdown.ItemText>
              <Dropdown.ItemText
                className="position-sticky bg-white py-2 border-top"
                style={{ bottom: 0 }}
              >
                <div className="row justify-content-between">
                  <div className="col col-auto">
                    <a
                      className="btn btn-light btn-sm text-uppercase"
                      onClick={clearFilters}
                    >
                      <i className="uil uil-times mr-2" />
                      Limpar Filtros
                    </a>
                  </div>
                  <div className="col col-auto">
                    <Button
                      type="submit"
                      className="btn-primary btn-sm text-uppercase"
                    >
                      Filtrar
                    </Button>
                  </div>
                </div>
              </Dropdown.ItemText>
            </Dropdown.Menu>
          </Dropdown>
        </C.Container>
      </form>
    </div>
  );
};

export default PatientQuoteReportSearch;
